export const USA_STATES = [
  {
    name: 'Alabama',
    code: 'al',
  },
  {
    name: 'Alaska',
    code: 'ak',
  },
  {
    name: 'Arizona',
    code: 'az',
  },
  {
    name: 'Arkansas',
    code: 'ar',
  },
  {
    name: 'California',
    code: 'ca',
  },
  {
    name: 'Colorado',
    code: 'co',
  },
  {
    name: 'Connecticut',
    code: 'ct',
  },
  {
    name: 'Delaware',
    code: 'de',
  },
  {
    name: 'District Of Columbia',
    code: 'dc',
  },
  {
    name: 'Florida',
    code: 'fl',
  },
  {
    name: 'Georgia',
    code: 'ga',
  },
  {
    name: 'Guam',
    code: 'gu',
  },
  {
    name: 'Hawaii',
    code: 'hi',
  },
  {
    name: 'Idaho',
    code: 'id',
  },
  {
    name: 'Illinois',
    code: 'il',
  },
  {
    name: 'Indiana',
    code: 'in',
  },
  {
    name: 'Iowa',
    code: 'ia',
  },
  {
    name: 'Kansas',
    code: 'ks',
  },
  {
    name: 'Kentucky',
    code: 'ky',
  },
  {
    name: 'Louisiana',
    code: 'la',
  },
  {
    name: 'Maine',
    code: 'me',
  },
  {
    name: 'Maryland',
    code: 'md',
  },
  {
    name: 'Massachusetts',
    code: 'ma',
  },
  {
    name: 'Michigan',
    code: 'mi',
  },
  {
    name: 'Minnesota',
    code: 'mn',
  },
  {
    name: 'Mississippi',
    code: 'ms',
  },
  {
    name: 'Missouri',
    code: 'mo',
  },
  {
    name: 'Montana',
    code: 'mt',
  },
  {
    name: 'Nebraska',
    code: 'ne',
  },
  {
    name: 'Nevada',
    code: 'nv',
  },
  {
    name: 'New Hampshire',
    code: 'nh',
  },
  {
    name: 'New Jersey',
    code: 'nj',
  },
  {
    name: 'New Mexico',
    code: 'nm',
  },
  {
    name: 'New York',
    code: 'ny',
  },
  {
    name: 'North Carolina',
    code: 'nc',
  },
  {
    name: 'North Dakota',
    code: 'nd',
  },
  {
    name: 'Ohio',
    code: 'oh',
  },
  {
    name: 'Oklahoma',
    code: 'ok',
  },
  {
    name: 'Oregon',
    code: 'or',
  },
  {
    name: 'Pennsylvania',
    code: 'pa',
  },
  {
    name: 'Puerto Rico',
    code: 'pr',
  },
  {
    name: 'Rhode Island',
    code: 'ri',
  },
  {
    name: 'South Carolina',
    code: 'sc',
  },
  {
    name: 'South Dakota',
    code: 'sd',
  },
  {
    name: 'Tennessee',
    code: 'tn',
  },
  {
    name: 'Texas',
    code: 'tx',
  },
  {
    name: 'Utah',
    code: 'ut',
  },
  {
    name: 'Vermont',
    code: 'vt',
  },
  {
    name: 'Virgin Islands',
    code: 'vi',
  },
  {
    name: 'Virginia',
    code: 'va',
  },
  {
    name: 'Washington',
    code: 'wa',
  },
  {
    name: 'West Virginia',
    code: 'wv',
  },
  {
    name: 'Wisconsin',
    code: 'wi',
  },
  {
    name: 'Wyoming',
    code: 'wy',
  },
];

export const AUS_STATES = [
  {
    name: 'Australian Capital Territory',
    code: 'act',
  },
  {
    name: 'New South Wales',
    code: 'nsw',
  },
  {
    name: 'Northern Terittory',
    code: 'nt',
  },
  {
    name: 'Queensland',
    code: 'qld',
  },
  {
    name: 'South Australia',
    code: 'sa',
  },
  {
    name: 'Tasmania',
    code: 'ta',
  },
  {
    name: 'Victoria',
    code: 'vic',
  },
  {
    name: 'Western Australia',
    code: 'wa',
  },
];

export const CAN_STATES = [
  {
    name: 'Alberta',
    code: 'ab',
  },
  {
    name: 'British Columbia',
    code: 'bc',
  },
  {
    name: 'Manitoba',
    code: 'mb',
  },
  {
    name: 'New Brunswick',
    code: 'nb',
  },
  {
    name: 'Newfoundland And Labrador',
    code: 'nl',
  },
  {
    name: 'Nova Scotia',
    code: 'ns',
  },
  {
    name: 'Northwest Territories',
    code: 'nt',
  },
  {
    name: 'Nunavut',
    code: 'nu',
  },
  {
    name: 'Ontario',
    code: 'on',
  },
  {
    name: 'Prince Edward Island',
    code: 'pe',
  },
  {
    name: 'Quebec',
    code: 'qc',
  },
  {
    name: 'Saskatchewan',
    code: 'sk',
  },
  {
    name: 'Yukon',
    code: 'yt',
  },
];

export const ECU_STATES = [
  {
    name: 'Azuay',
    code: 'az',
  },
  {
    name: 'Bolivar',
    code: 'bo',
  },
  {
    name: 'Chimborazo',
    code: 'cb',
  },
  {
    name: 'Canar',
    code: 'cn',
  },
  {
    name: 'Carchi',
    code: 'cr',
  },
  {
    name: 'Cotopaxi',
    code: 'ct',
  },
  {
    name: 'El Oro',
    code: 'eo',
  },
  {
    name: 'Esmeraldas',
    code: 'es',
  },
  {
    name: 'Galapagos',
    code: 'ga',
  },
  {
    name: 'Guayas',
    code: 'gu',
  },
  {
    name: 'Imbabura',
    code: 'im',
  },
  {
    name: 'Loja',
    code: 'lj',
  },
  {
    name: 'Los Rios',
    code: 'lr',
  },
  {
    name: 'Manabi',
    code: 'mn',
  },
  {
    name: 'Morona-santiago',
    code: 'ms',
  },
  {
    name: 'Napo',
    code: 'na',
  },
  {
    name: 'Orellana',
    code: 'or',
  },
  {
    name: 'Pastaza',
    code: 'pa',
  },
  {
    name: 'Pichincha',
    code: 'pi',
  },
  {
    name: 'Sucumbios',
    code: 'su',
  },
  {
    name: 'Tungurahua',
    code: 'tu',
  },
  {
    name: 'Zamora-chinchipe',
    code: 'zc',
  },
];

export const CRI_PROVINCE = [
  {
    name: 'Aljuela',
    code: 'alj',
    subList: [
      {
        name: 'Alajuela',
        code: 'ala'
      },
      {
        name: 'San Ramón',
        code: 'srm'
      },
      {
        name: 'Grecia',
        code: 'gre'
      },
      {
        name: 'San Mateo',
        code: 'sma'
      },
      {
        name: 'Atenas',
        code: 'ate'
      },
      {
        name: 'Naranjo',
        code: 'nar'
      },
      {
        name: 'Palmares',
        code: 'pal'
      },
      {
        name: 'Poás',
        code: 'poa'
      },
      {
        name: 'Orotina',
        code: 'oro'
      },
      {
        name: 'San Carlos',
        code: 'sca'
      },
      {
        name: 'Zarcero',
        code: 'zar'
      },
      {
        name: 'Sarchí',
        code: 'sch'
      },
      {
        name: 'Upala',
        code: 'upa'
      },
      {
        name: 'Los Chiles',
        code: 'lch'
      },
      {
        name: 'Guatuso',
        code: 'gts'
      },
      {
        name: 'Río Cuarto',
        code: 'rcu'
      }
    ]
  },
  {
    name: 'Cartgo',
    code: 'car',
    subList: [
      {
        name: 'Cartago',
        code: 'ctg'
      },
      {
        name: 'Paraíso',
        code: 'prs'
      },
      {
        name: 'La Unión',
        code: 'lun'
      },
      {
        name: 'Jiménez',
        code: 'jim'
      },
      {
        name: 'Turrialba',
        code: 'trl'
      },
      {
        name: 'Alvarado',
        code: 'alv'
      },
      {
        name: 'Oreamuno',
        code: 'ore'
      },
      {
        name: 'El Guarco',
        code: 'egu'
      }
    ]
  },
  {
    name: 'Guanacaste',
    code: 'gua',
    subList: [
      {
        name: 'Liberia',
        code: 'lib'
      },
      {
        name: 'Nicoya',
        code: 'nic'
      },
      {
        name: 'Santa Cruz',
        code: 'scr'
      },
      {
        name: 'Bagaces',
        code: 'bag'
      },
      {
        name: 'Carrillo',
        code: 'crl'
      },
      {
        name: 'Cañas',
        code: 'can'
      },
      {
        name: 'Abangares',
        code: 'aba'
      },
      {
        name: 'Tilarán',
        code: 'til'
      },
      {
        name: 'Nandayure',
        code: 'nan'
      },
      {
        name: 'La Cruz',
        code: 'lcr'
      },
      {
        name: 'Hojancha',
        code: 'hoj'
      }
    ]
  },
  {
    name: 'Heredia',
    code: 'her',
    subList: [
      {
        name: 'Heredia',
        code: 'her'
      },
      {
        name: 'Barva',
        code: 'bar'
      },
      {
        name: 'Santo Domingo',
        code: 'sdo'
      },
      {
        name: 'Santa Bárbara',
        code: 'sba'
      },
      {
        name: 'San Rafael',
        code: 'srf'
      },
      {
        name: 'San Isidro',
        code: 'sis'
      },
      {
        name: 'Belén',
        code: 'bel'
      },
      {
        name: 'Flores',
        code: 'flo'
      },
      {
        name: 'San Pablo',
        code: 'spa'
      },
      {
        name: 'Sarapiquí',
        code: 'saq'
      }
    ]
  },
  {
    name: 'Limon',
    code: 'lim',
    subList: [
      {
        name: 'Limón',
        code: 'lmo'
      },
      {
        name: 'Pococí',
        code: 'poc'
      },
      {
        name: 'Siquirres',
        code: 'siq'
      },
      {
        name: 'Talamanca',
        code: 'tal'
      },
      {
        name: 'Matina',
        code: 'mat'
      },
      {
        name: 'Guácimo',
        code: 'gcm'
      }
    ]
  },
  {
    name: 'Puntarenas',
    code: 'pun',
    subList: [
      {
        name: 'Buenos Aires',
        code: 'bai'
      },
      {
        name: 'Corredores',
        code: 'cor'
      },
      {
        name: 'Coto Brus',
        code: 'cbr'
      },
      {
        name: 'Esparza',
        code: 'esp'
      },
      {
        name: 'Garabito',
        code: 'gar'
      },
      {
        name: 'Golfito',
        code: 'gol'
      },
      {
        name: 'Montes de Oro',
        code: 'mor'
      },
      {
        name: 'Osa',
        code: 'osa'
      },
      {
        name: 'Parrita',
        code: 'prt'
      },
      {
        name: 'Puntarenas',
        code: 'ptn'
      },
      {
        name: 'Quepos',
        code: 'que'
      }
    ]
  },
  {
    name: 'San Jose',
    code: 'sjo',
    subList: [
      {
        name: 'San José',
        code: 'sjo'
      },
      {
        name: 'Escazú',
        code: 'esc'
      },
      {
        name: 'Desamparados',
        code: 'des'
      },
      {
        name: 'Puriscal',
        code: 'pur'
      },
      {
        name: 'Tarrazú',
        code: 'tar'
      },
      {
        name: 'Aserrí',
        code: 'ase'
      },
      {
        name: 'Mora',
        code: 'mra'
      },
      {
        name: 'Goicoechea',
        code: 'goi'
      },
      {
        name: 'Santa Ana',
        code: 'san'
      },
      {
        name: 'Alajuelita',
        code: 'ata'
      },
      {
        name: 'Vázquez de Coronado',
        code: 'vdc'
      },
      {
        name: 'Acosta',
        code: 'aco'
      },
      {
        name: 'Tibás',
        code: 'tib'
      },
      {
        name: 'Moravia',
        code: 'mvi'
      },
      {
        name: 'Montes de Oca',
        code: 'moc'
      },
      {
        name: 'Turrubares',
        code: 'tbr'
      },
      {
        name: 'Dota',
        code: 'dot'
      },
      {
        name: 'Curridabat',
        code: 'cur'
      },
      {
        name: 'Pérez Zeledón',
        code: 'pze'
      },
      {
        name: 'León Cortés Castro',
        code: 'lcc'
      }
    ]
  },
];

export const IND_STATES = [
  {
    name: 'Andaman And Nicobar Islands',
    code: 'an',
  },
  {
    name: 'Andhra Pradesh',
    code: 'ap',
  },
  {
    name: 'Arunachal Pradesh',
    code: 'ar',
  },
  {
    name: 'Assam',
    code: 'as',
  },
  {
    name: 'Bihar',
    code: 'br',
  },
  {
    name: 'Chhattisgarh',
    code: 'cg',
  },
  {
    name: 'Chandigarh',
    code: 'ch',
  },
  {
    name: 'Daman & Diu',
    code: 'dd',
  },
  {
    name: 'Delhi',
    code: 'dl',
  },
  {
    name: 'Dadra & Nagar Haveli',
    code: 'dn',
  },
  {
    name: 'Goa',
    code: 'ga',
  },
  {
    name: 'Gujarat',
    code: 'gj',
  },
  {
    name: 'Himachal Pradesh',
    code: 'hp',
  },
  {
    name: 'Haryana',
    code: 'hr',
  },
  {
    name: 'Jharkhand',
    code: 'jh',
  },
  {
    name: 'Jammu & Kashmir',
    code: 'jk',
  },
  {
    name: 'Karnataka',
    code: 'ka',
  },
  {
    name: 'Kerala',
    code: 'kl',
  },
  {
    name: 'Lakshadweep Islands',
    code: 'ld',
  },
  {
    name: 'Maharashtra',
    code: 'mh',
  },
  {
    name: 'Meghalaya',
    code: 'ml',
  },
  {
    name: 'Manipur',
    code: 'mn',
  },
  {
    name: 'Madhya Pradesh',
    code: 'mp',
  },
  {
    name: 'Mizoram',
    code: 'mz',
  },
  {
    name: 'Nagaland',
    code: 'nl',
  },
  {
    name: 'Odisha (orissa)',
    code: 'or',
  },
  {
    name: 'Punjab',
    code: 'pb',
  },
  {
    name: 'Pondicherry',
    code: 'py',
  },
  {
    name: 'Rajasthan',
    code: 'rj',
  },
  {
    name: 'Sikkim',
    code: 'sk',
  },
  {
    name: 'Tamil Nadu',
    code: 'tn',
  },
  {
    name: 'Tripura',
    code: 'tr',
  },
  {
    name: 'Telangana',
    code: 'ts',
  },
  {
    name: 'Uttarakhand (uttaranchal)',
    code: 'uk',
  },
  {
    name: 'Uttar Pradesh',
    code: 'up',
  },
  {
    name: 'West Bengal',
    code: 'wb',
  },
];

export const COUNTRIES = [
  {
    name: 'United States',
    code: 'usa',
    placeHolder: '<p>House number</p>',
    outputData: '<p>addressLine1</p>addressLine2 <p>city, states, zipCode</p>',
  },
  {
    name: 'United Kingdom',
    code: 'gbr',
    placeHolder: '<p>House number</p>',
    outputData: '<p>addressLine1</p>addressLine2 <p>city</p> <p>postcode</p>',
  },
  {
    name: 'Australia',
    code: 'aus',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>suburb, postcode, states</p>',
  },
  {
    name: 'New Zealand',
    code: 'nzl',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>states</p> <p>city, postalCode</p>',
  },
  {
    name: 'Canada',
    code: 'can',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>city states  postalCode</p>',
  },
  {
    name: 'Mexico',
    code: 'mex',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>postalCode, states, city</p>',
  },
  {
    name: 'India',
    code: 'ind',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>city</p> <p>states</p> <p>postcode</p>',
  },
  {
    name: 'Costa Rica',
    code: 'cri',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>states, canton, district, postalCode</p>',
  },
  {
    name: 'Argentina',
    code: 'arg',
    placeHolder: '<p>House number</p>',
    outputData: '<p>addressLine1</p>addressLine2 <p>postcode town</p>',
  },
  {
    name: 'Ecuador',
    code: 'ecu',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>postcode</p><p>city</p><p>states</p>',
  },
  {
    name: 'Peru',
    code: 'per',
    placeHolder: '<p>House number</p>',
    outputData:
      '<p>addressLine1</p>addressLine2 <p>department</p><p>province</p><p>district</p>',
  },
  {
    name: 'French Guiana',
    code: 'guf',
    placeHolder: '<p>House number</p>',
    outputData: '<p>addressLine1</p>addressLine2 <p>postcode town</p>',
  },
];

export const COUNTRIES_CONSTANT = {
  usa: {
    name: 'United States',
    code: 'usa',
  },
  cri: {
    name: 'Costa Rica',
    code: 'cri',
  },
  guf: {
    name: 'French Guiana',
    code: 'guf',
  },
};
